import { CaseRoomMainColumn } from './case-room-main-column';
import { FilterPanel } from './filter-panel';
import { MembersPanel } from './members-panel';
import { SourcesPanelOverlay } from './sources-panel-overlay';
import { useCaseRoomController } from './use-case-room-controller';

export function CaseRoomPage() {
  const {
    caseId,
    caseItem,
    pageState,
    focus,
    timeline,
    eventCounts,
    previewEvent,
    openSources,
    canInvite,
  } = useCaseRoomController();

  return (
    <div className="flex h-[calc(100dvh-3rem)] w-full">
      <FilterPanel
        filters={pageState.filters}
        counts={eventCounts?.typeCounts ?? {}}
        attachmentCount={eventCounts?.attachmentCount ?? 0}
        starredCount={pageState.starredCount}
        onChange={pageState.setFilters}
      />
      <CaseRoomMainColumn
        caseId={caseId}
        caseItem={caseItem}
        filters={pageState.filters}
        starredCount={pageState.starredCount}
        dateMin={timeline.dateMin}
        dateMax={timeline.dateMax}
        rows={timeline.rows}
        isLoading={timeline.isLoading}
        isFetchingNextPage={timeline.isFetchingNextPage}
        hasNextPage={timeline.hasNextPage}
        selectedId={pageState.selectedEvent?.id ?? null}
        expandedEvent={previewEvent ?? null}
        highlightedEventIds={pageState.highlightedEventIds}
        canToggleHighlight={pageState.canToggleHighlight}
        scrollToEventId={focus.scrollToEventId}
        onScrolledToEvent={focus.onScrolledToEvent}
        onFiltersChange={pageState.setFilters}
        onSourcesClick={openSources}
        onSelect={pageState.handleSelect}
        onDeselect={pageState.deselectEvent}
        onToggleHighlight={(event, isHighlighted) =>
          pageState.toggleHighlight.mutate({ event, isHighlighted })
        }
        fetchNextPage={timeline.fetchNextPage}
      />
      {pageState.isMembersOpen && (
        <MembersPanel
          caseId={caseId}
          canInvite={canInvite}
          onClose={() => pageState.setIsMembersOpen(false)}
        />
      )}
      {pageState.isSourcesOpen && (
        <SourcesPanelOverlay caseId={caseId} onClose={() => pageState.setIsSourcesOpen(false)} />
      )}
    </div>
  );
}
